document.addEventListener("DOMContentLoaded", function () {
    let swipers = [];
    let swipersMobile = [];
    let swipersCompare = [];

    function initSwiperOnMobile() {
        let gridsMobile = document.querySelectorAll(".swiper-grid-mobile");
        let simpleMobiles = document.querySelectorAll(".swiper-mobile");
        let compare = document.querySelectorAll(".swiper-compare");

        gridsMobile.forEach((grid, index) => {
            let existingSwiper = grid.swiper;

            if (window.innerWidth <= 768) {
                if (!existingSwiper) {
                    let swiperInstance = new Swiper(grid, {
                        slidesPerView: 1,
                        autoplay: true,
                        centeredSlides: true,
                        createElements: true,
                        loop: false,
                        grabCursor: true,
                        initialSlide: 0,
                        keyboard: true,
                        navigation: true,
                        pagination: true,
                        simulateTouch: true,
                        lazy: { enabled: true },
                        watchSlidesProgress: true,
                        observer: true,
                        observeParents: true,
                        resizeObserver: true,
                    });

                    swipers.push(swiperInstance);
                }
            } else {
                if (existingSwiper) {
                    existingSwiper.destroy(true, true);
                    swipers = swipers.filter((s) => s !== existingSwiper);
                }
            }
        });

        simpleMobiles.forEach((mobile) => {
            let existingSwiper = mobile.swiper;

            if (window.innerWidth <= 768) {
                if (!existingSwiper) {
                    let swiperInstance = new Swiper(mobile, {
                        slidesPerView: 1,
                        autoplay: true,
                        spaceBetween: 80,
                        centeredSlides: true,
                        createElements: true,
                        loop: false,
                        grabCursor: true,
                        initialSlide: 0,
                        keyboard: true,
                        navigation: true,
                        pagination: true,
                        simulateTouch: true,
                        lazy: { enabled: true },
                        watchSlidesProgress: true,
                        observer: true,
                        observeParents: true,
                        resizeObserver: true,
                    });

                    swipersMobile.push(swiperInstance);
                }
            } else {
                if (existingSwiper) {
                    existingSwiper.destroy(true, true);
                    swipersMobile = swipersMobile.filter(
                        (s) => s !== existingSwiper
                    );
                }
            }
        });

        const hasUpgradeBlock = document.querySelector('.upgrade-block') !== null;

        compare.forEach((grid) => {
            const existing = grid.swiper;
            if (existing) return; // ne pas recréer
          
            const hasUpgradeBlock = document.querySelector('.upgrade-block') !== null;
          
            const swiperInstance = new Swiper(grid, {
              // centrage “vrai”
              slidesPerView: 'auto',
              centeredSlides: !hasUpgradeBlock,
              centeredSlidesBounds: !hasUpgradeBlock,
              centerInsufficientSlides: true,
              spaceBetween: 20,
          
              navigation: {
                enabled: true,
                prevEl: ".compare-prev",
                nextEl: ".compare-next",
              },
              pagination: {
                el: ".swiper-pagination",
                enabled: true,
                clickable: true,
                dynamicBullets: true,
              },
          
              // breakpoints: on ajuste juste l'espacement si besoin
              breakpoints: hasUpgradeBlock ? {
                1600: { spaceBetween: 16 },
                1800: { spaceBetween: 32 }
              } : {
                1000: { spaceBetween: 8 },
                1200: { spaceBetween: 8 },
                1600: { spaceBetween: 16 },
                1800: { spaceBetween: 24 },
                2500: { spaceBetween: 32 }
              },
          
              // si tu veux démarrer sur la carte du milieu
              on: {
                init(sw) {
                  const mid = Math.floor(sw.slides.length / 2);
                  sw.slideTo(mid, 0, false);
                }
              },
          
              // tes options usuelles
              watchSlidesProgress: true,
              observer: true,
              observeParents: true,
              resizeObserver: true
            });
          
            swipersCompare.push(swiperInstance);
          });
          
    }

    initSwiperOnMobile();
    window.addEventListener("resize", initSwiperOnMobile);
});
